import apiService from '../../../services/apiService';

// Note: Class module uses Class for centers and CommonChannel for user management
const CLASS_API = '/api/Class';
const COMMON_API = '/ykrestapi/CommonChannel';

export const classService = {
  getCenters: async (countryDesc = 'USA') => {
    try {
      const response = await apiService.get(`${CLASS_API}/GetAllCenters`);
      return response.data;
    } catch (error) {
      console.error('Error fetching centers:', error);
      throw error;
    }
  },

  getCategoriesByCenter: async (centerId) => {
    try {
      const response = await apiService.post(`${CLASS_API}/FetchCategory`, {
        Category_Id: parseInt(centerId),
        Center_Id: parseInt(centerId),
        Category_Name: '',
        Category_Description: '',
        Status: '',
        Category_Type: '',
        Category_Create_Date: new Date().toISOString(),
        Category_Createby: '',
        Category_UpdatedDate: new Date().toISOString(),
        class_desc: '',
        Category_Img_Url: '',
        ClassCount: 0
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },

  getClassesByCategory: async (categoryId, centerId) => {
    try {
      const response = await apiService.post(`${CLASS_API}/FetchClasses`, {
        class_Id: 0,
        instructor_Id: 0,
        center_Id: parseInt(centerId),
        venue_Id: 0,
        program_Id: 0,
        centre_Id: 0,
        course_Id: 0,
        class_Name: '',
        class_Description: '',
        class_Internal_Comment: '',
        class_Number_Of_Sessions: 0,
        class_Capacity: 0,
        class_Waitlist_Capacity: 0,
        class_Date_From: new Date().toISOString(),
        class_Date_To: new Date().toISOString(),
        class_Time_From: '',
        class_Time_To: '',
        class_Total_Duration_Hours: 0,
        class_Prerequisities: '',
        class_Eval_Criteria: '',
        createdBy: '',
        created: new Date().toISOString(),
        modifiedBy: '',
        modified: new Date().toISOString(),
        status: '',
        class_Fee: 0,
        class_Image_Url: '',
        category_Id: parseInt(categoryId),
        class_Internal_Comments: '',
        instructorName: ''
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching classes by category:', error);
      throw error;
    }
  },

  getClassDetails: async (classId) => {
    try {
      const response = await apiService.post(`${CLASS_API}/FetchClassDetails`, {
        class_Id: parseInt(classId),
        instructor_Id: 0,
        center_Id: 0,
        venue_Id: 0,
        program_Id: 0,
        centre_Id: 0,
        course_Id: 0,
        class_Name: '',
        class_Description: '',
        class_Internal_Comment: '',
        class_Number_Of_Sessions: 0,
        class_Capacity: 0,
        class_Waitlist_Capacity: 0,
        class_Date_From: new Date().toISOString(),
        class_Date_To: new Date().toISOString(),
        class_Time_From: '',
        class_Time_To: '',
        class_Total_Duration_Hours: 0,
        class_Prerequisities: '',
        class_Eval_Criteria: '',
        createdBy: '',
        created: new Date().toISOString(),
        modifiedBy: '',
        modified: new Date().toISOString(),
        status: '',
        class_Fee: 0,
        class_Image_Url: '',
        category_Id: 0,
        class_Internal_Comments: '',
        instructorName: ''
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching class details:', error);
      throw error;
    }
  },

  getClassesByCenter: async (centerId, countryDesc = 'USA') => {
    try {
      const response = await apiService.post(`${CLASS_API}/GetCamp`, {
        Camp_Id: 0,
        Center_Id: parseInt(centerId),
        Camp_Name: '',
        Camp_Description: '',
        Camp_Fee: 0,
        Camp_Date_To: new Date().toISOString(),
        Camp_Date_From: new Date().toISOString(),
        Camp_Image_Url: '',
        Camp_Type: 'CL',
        App_Id: 1,
        Organization_Id: 0,
        Country_Desc: countryDesc,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching classes:', error);
      throw error;
    }
  },

  getAccommodationAndCampDate: async (campData) => {
    try {
      const response = await apiService.post(`${CLASS_API}/GetAccommodationFeeAndCampDate`, campData);
      return response.data;
    } catch (error) {
      console.error('Error fetching accommodation and camp date:', error);
      throw error;
    }
  },

  addClassRegistration: async (registrationData) => {
    try {
      const response = await apiService.post(`${CLASS_API}/AddRetreatRegistration`, registrationData);
      return response.data;
    } catch (error) {
      console.error('Error adding class registration:', error);
      throw error;
    }
  },

  addClassRegistrationDetail: async (detailData) => {
    try {
      const response = await apiService.post(`${CLASS_API}/AddRetreatRegistrationDetail`, detailData);
      return response.data;
    } catch (error) {
      console.error('Error adding class registration detail:', error);
      throw error;
    }
  },

  getClassCalculation: async (registeredData) => {
    try {
      const response = await apiService.post(`${CLASS_API}/GetRetreatCalculation`, registeredData);
      return response.data;
    } catch (error) {
      console.error('Error fetching class calculation:', error);
      throw error;
    }
  },

  updatePaymentStatus: async (paymentData) => {
    try {
      const response = await apiService.post(`${CLASS_API}/UpdatePaymentStatus`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error updating payment status:', error);
      throw error;
    }
  },

  getEnrolledStudents: async (paymentData) => {
    try {
      const response = await apiService.post(`${CLASS_API}/GetRetreatEnrolledStudents`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error fetching enrolled students:', error);
      throw error;
    }
  },

  getUserRegistrationDetails: async (userId) => {
    try {
      const response = await apiService.post(`${CLASS_API}/GetUserRegistrationDetails`, {
        userId,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching user registration details:', error);
      throw error;
    }
  },

  updateUserDetails: async (userDetails) => {
    try {
      const response = await apiService.post(`${CLASS_API}/UpdateUserDetail`, userDetails);
      return response.data;
    } catch (error) {
      console.error('Error updating user details:', error);
      throw error;
    }
  },

  validateUser: async (userLoginParam) => {
    try {
      const response = await apiService.post(`${COMMON_API}/ValidateUser`, userLoginParam);
      return response.data;
    } catch (error) {
      console.error('Error validating user:', error);
      throw error;
    }
  },

  fetchStudentDetails: async (userId, classId) => {
    try {
      const response = await apiService.post(`${CLASS_API}/FetchStudentDetails`, {
        // Send both camelCase (for local with JsonPropertyName) and PascalCase (for production)
        studentId: 0,
        Student_Id: 0,
        classId: parseInt(classId),
        Class_Id: parseInt(classId),
        campId: 0,
        Camp_Id: 0,
        enrollmentId: 0,
        Enrollment_Id: 0,
        userId: parseInt(userId),
        User_id: parseInt(userId),
        student_Last_Name: '',
        Student_Last_Name: '',
        student_First_Name: '',
        Student_First_Name: '',
        student_Date_Of_Birth: new Date().toISOString(),
        Student_Date_Of_Birth: new Date().toISOString(),
        student_Date_Of_Birth1: '',
        Student_Date_Of_Birth1: '',
        student_Age: 0,
        Student_Age: 0,
        parent_Last_Name: '',
        Parent_Last_Name: '',
        parent_First_Name: '',
        Parent_First_Name: '',
        student_Email: '',
        Student_Email: '',
        student_Phone: '',
        Student_Phone: '',
        student_Address_Line1: '',
        Student_Address_Line1: '',
        student_Address_Line2: '',
        Student_Address_Line2: '',
        student_City: '',
        Student_City: '',
        student_Country: '',
        Student_Country: '',
        state_Id: 0,
        State_Id: 0,
        student_Zip_Code: 0,
        Student_Zip_Code: 0,
        student_Internal_Comments: '',
        Student_Internal_Comments: '',
        student_Gender: '',
        Student_Gender: '',
        student_Relationship_To_User: '',
        Student_Relationship_To_User: '',
        student_Occupation: '',
        Student_Occupation: '',
        status: '',
        Status: '',
        createdBy: '',
        created: new Date().toISOString(),
        modifiedBy: '',
        modified: new Date().toISOString(),
        student_Age_Group_Id: 0,
        is_Accommodation_Needed: '',
        seva_Opportunity_Id: 0,
        registerSession_Count: 0,
        selected_Session_Count: 0,
        selected_To_Pay_Amt: 0,
        extended_Amt: 0,
        registered_Session_Count: 0,
        registered_To_Pay_Amt: 0,
        user_Email: '',
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching student details:', error);
      throw error;
    }
  },

  getRegisteredStudents: async (userId, classId) => {
    try {
      const response = await apiService.post(`${CLASS_API}/GetRegisteredStudents`, {
        // Send both camelCase and PascalCase for compatibility
        studentId: 0,
        Student_Id: 0,
        classId: parseInt(classId),
        Class_Id: parseInt(classId),
        campId: 0,
        Camp_Id: 0,
        enrollmentId: 0,
        Enrollment_Id: 0,
        userId: parseInt(userId),
        User_id: parseInt(userId),
        student_Last_Name: '',
        Student_Last_Name: '',
        student_First_Name: '',
        Student_First_Name: '',
        student_Date_Of_Birth: new Date().toISOString(),
        Student_Date_Of_Birth: new Date().toISOString(),
        student_Date_Of_Birth1: '',
        Student_Date_Of_Birth1: '',
        student_Age: 0,
        Student_Age: 0,
        parent_Last_Name: '',
        Parent_Last_Name: '',
        parent_First_Name: '',
        Parent_First_Name: '',
        student_Email: '',
        Student_Email: '',
        student_Phone: '',
        Student_Phone: '',
        student_Address_Line1: '',
        Student_Address_Line1: '',
        student_Address_Line2: '',
        Student_Address_Line2: '',
        student_City: '',
        Student_City: '',
        student_Country: '',
        Student_Country: '',
        state_Id: 0,
        State_Id: 0,
        student_Zip_Code: 0,
        Student_Zip_Code: 0,
        student_Internal_Comments: '',
        Student_Internal_Comments: '',
        student_Gender: '',
        Student_Gender: '',
        student_Relationship_To_User: '',
        Student_Relationship_To_User: '',
        student_Occupation: '',
        Student_Occupation: '',
        status: '',
        createdBy: '',
        created: new Date().toISOString(),
        modifiedBy: '',
        modified: new Date().toISOString(),
        student_Age_Group_Id: 0,
        is_Accommodation_Needed: '',
        seva_Opportunity_Id: 0,
        registerSession_Count: 0,
        selected_Session_Count: 0,
        selected_To_Pay_Amt: 0,
        extended_Amt: 0,
        registered_Session_Count: 0,
        registered_To_Pay_Amt: 0,
        user_Email: '',
      });
      return response.data;
    } catch (error) {
      console.error('Error checking registered students:', error);
      throw error;
    }
  },

  addStudent: async (studentData) => {
    try {
      const payload = {
        studentId: 0,
        classId: parseInt(studentData.classId),
        campId: 0,
        enrollmentId: 0,
        userId: parseInt(studentData.userId),
        lastName: studentData.lastName || '',
        firstName: studentData.firstName || '',
        dateOfBirth: studentData.dateOfBirth ? new Date(studentData.dateOfBirth).toISOString() : null,
        Student_Age: 0,
        Parent_Last_Name: '',
        Parent_First_Name: '',
        Student_Email: '',
        Student_Phone: '',
        Student_Address_Line1: '',
        Student_Address_Line2: '',
        Student_City: '',
        Student_Country: '',
        State_Id: 0,
        Student_Zip_Code: 0,
        Student_Internal_Comments: '',
        gender: studentData.gender === 'Male' ? 'M' : studentData.gender === 'Female' ? 'F' : '',
        relationship: studentData.relationship || '',
        Student_Occupation: '',
        Status: 'Active',
        createdBy: studentData.userId?.toString() || '',
        Student_Age_Group_Id: 0,
        Is_Accommodation_Needed: '',
        Seva_Opportunity_Id: 0,
        RegisterSession_Count: 0,
        Selected_Session_Count: 0,
        Selected_To_Pay_Amt: 0,
        Extended_Amt: 0,
        Registered_Session_Count: 0,
        Registered_To_Pay_Amt: 0,
        User_Email: '',
      };
      
      console.log('API Payload being sent:', payload);
      console.log('userId value:', payload.userId);
      console.log('classId value:', payload.classId);
      
      const response = await apiService.post(`${CLASS_API}/AddStudent`, payload);
      return response.data;
    } catch (error) {
      console.error('Error adding student:', error);
      throw error;
    }
  },

  updateStudent: async (studentData) => {
    try {
      const payload = {
        studentId: parseInt(studentData.studentId) || 0,
        classId: parseInt(studentData.classId),
        campId: 0,
        enrollmentId: 0,
        userId: parseInt(studentData.userId),
        lastName: studentData.lastName || '',
        firstName: studentData.firstName || '',
        dateOfBirth: studentData.dateOfBirth ? new Date(studentData.dateOfBirth).toISOString() : null,
        Student_Age: 0,
        Parent_Last_Name: '',
        Parent_First_Name: '',
        Student_Email: '',
        Student_Phone: '',
        Student_Address_Line1: '',
        Student_Address_Line2: '',
        Student_City: '',
        Student_Country: '',
        State_Id: 0,
        Student_Zip_Code: 0,
        Student_Internal_Comments: '',
        gender: studentData.gender === 'Male' ? 'M' : studentData.gender === 'Female' ? 'F' : '',
        relationship: studentData.relationship || '',
        Student_Occupation: '',
        Status: 'Active',
        createdBy: studentData.userId?.toString() || '',
        Student_Age_Group_Id: 0,
        Is_Accommodation_Needed: '',
        Seva_Opportunity_Id: 0,
        RegisterSession_Count: 0,
        Selected_Session_Count: 0,
        Selected_To_Pay_Amt: 0,
        Extended_Amt: 0,
        Registered_Session_Count: 0,
        Registered_To_Pay_Amt: 0,
        User_Email: '',
      };
      
      console.log('UpdateStudent API Payload:', payload);
      const response = await apiService.post(`${CLASS_API}/UpdateStudent`, payload);
      return response.data;
    } catch (error) {
      console.error('Error updating student:', error);
      throw error;
    }
  },

  getCampEnrollmentInfo: async (campId, userId) => {
    try {
      const response = await apiService.post('/api/Camp/GetCampEnrollmentInfo', {
        campId,
        userId,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching camp enrollment info:', error);
      throw error;
    }
  },

  getClassSessions: async (classId) => {
    try {
      const response = await apiService.post(`${CLASS_API}/GetClassSession`, {
        Class_Id: parseInt(classId),
        Instructor_Id: 0,
        Center_Id: 0,
        Venue_Id: 0,
        Program_Id: 0,
        Centre_Id: 0,
        Course_Id: 0,
        Class_Name: '',
        Class_Description: '',
        Class_Internal_Comment: '',
        Class_Number_Of_Sessions: 0,
        Class_Capacity: 0,
        Class_Waitlist_Capacity: 0,
        Class_Date_From: new Date().toISOString(),
        Class_Date_To: new Date().toISOString(),
        Class_Time_From: '',
        Class_Time_To: '',
        Class_Total_Duration_Hours: 0,
        Class_Prerequisities: '',
        Class_Eval_Criteria: '',
        CreatedBy: 'API',
        Created: new Date().toISOString(),
        ModifiedBy: 'API',
        Modified: new Date().toISOString(),
        Status: 'Active',
        Class_Fee: 0,
        Class_Image_Url: '',
        Category_Id: 0,
        Class_Internal_Comments: '',
        InstructorName: ''
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching class sessions:', error);
      throw error;
    }
  },

  getInstructorById: async (instructorId) => {
    try {
      const response = await apiService.get(`${CLASS_API}/FetchInstructor/${parseInt(instructorId)}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching instructor:', error);
      throw error;
    }
  },

  getInstructorMedia: async (instructorId) => {
    try {
      const response = await apiService.post(`${CLASS_API}/FetchInstructorMedia`, {
        Instructor_Id: parseInt(instructorId),
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching instructor media:', error);
      return [];
    }
  },
};

export default classService;
